import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriversTable from '../drivers-table';

export class DriversDashboard extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="g4-logistics-portal-drivers-dashboard">
                <div className="zone-jobs-container">
                    <DriversTable
                        url="/api/v1/portal/drivers/with-jobs"
                        message_if_none='Tablets not found or available for viewing.'
                        isDriverDashboardPage={true}
                    />
                </div>
            </div>
        );
    }
}

if (document.getElementById('react-component-g4-logistics-portal-drivers-dashboard')) {
    ReactDOM.render(<DriversDashboard />, document.getElementById('react-component-g4-logistics-portal-drivers-dashboard'));
}